export default __webpack_public_path__ + "static/media/target-icon.6f188027.svg";